<template>
  <header>
    <router-link to="/" class="button-back" v-show="backShow">
      <img
        src="../assets/images/header/back.png"
        class="button-back--img"
        alt=""
      />
    </router-link>
    <div class="button-wrap" v-if="UPLOAD_OPEN">
      <div class="button-box button-submit">
        <router-link class="button-a" to="/post">動画を推薦</router-link>
      </div>
      <div class="button-box button-login" @click="login">
        {{ NICK_NAME ? "サインアウト" : "ログイン" }}
      </div>
    </div>

    <div class="button-back--title" @click="reset"></div>
  </header>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Header",

  components: {},
  data: () => ({}),
  created() {},
  mounted() {
    // 设置header bg
    document.querySelector("header").style.setProperty('--headerBgPc', `url("https://webusstatic.yo-star.com/${this.HEAD_BANNER_PC}")`);
    document.querySelector("header").style.setProperty('--headerBgMobile', `url("https://webusstatic.yo-star.com/${this.HEAD_BANNER_MOBILE}")`)
  },
  watch: {},
  computed: {
    ...mapState({
      NICK_NAME: (state) => state.User.NICK_NAME,
      UPLOAD_OPEN: (state) => state.Config.UPLOAD_OPEN,
      HEAD_BANNER_PC: (state) => state.Config.HEAD_BANNER_PC,
      HEAD_BANNER_MOBILE: (state) => state.Config.HEAD_BANNER_MOBILE,
    }),
    backShow() {
      return this.$route.name !== "home";
    },
  },
  methods: {
    reset() {
      if (this.$route.name == "home") {
        // 在首页点击
        this.$store.dispatch("Home/clearFilter");
        location.reload();
      } else {
        this.$router.push({ path: "/" });
      }
    },
    login() {
      if (!this.NICK_NAME) {
        this.$router.replace({ path: "login" });
      } else {
        this.$store
          .dispatch("User/logout")
          .then((v) => {
            if (v.retcode == 2000) {
              this.$router.replace({ path: "/" });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  height: 0;
  padding-bottom: 10.42%;
  background: var(--headerBgPc) no-repeat;
  background-size: cover;
  position: relative;

  .button-wrap {
    position: absolute;
    top: pxTorem(20px);
    right: pxTorem(15px);
    font-size: pxTorem(16px);
    display: flex;

    .button-box {
      height: pxTorem(38px);
      line-height: pxTorem(36px);
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;
    }

    .button-submit {
      width: pxTorem(210px);
      border: 1px solid #000;
      background: #00b2ff;
      margin-right: pxTorem(10px);

      .button-a {
        color: #000;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .button-login {
      padding: 0 pxTorem(15px);
      background: #000;
      border: 1px solid #00b2ff;
      color: #00b2ff;
    }
  }

  .button-back {
    width: pxTorem(84px);
    position: absolute;
    top: pxTorem(68px);
    left: pxTorem(41px);
    cursor: pointer;

    .button-back--img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .button-back--title {
    position: absolute;
    width: pxTorem(600px);
    height: pxTorem(100px);
    cursor: pointer;
    top: pxTorem(68px);
    left: pxTorem(300px);
  }
}
@media screen and (max-width: 600px) {
  header {
    width: 100%;
    height: 0;
    padding-bottom: 18.8%;
    background: var(--headerBgMobile) no-repeat;
    background-size: cover;
    position: relative;

    .button-wrap {
      position: absolute;
      top: MpxTorem(36px);
      right: MpxTorem(20px);
      font-size: MpxTorem(16px);
      display: block;

      .button-box {
        width: MpxTorem(390px);
        position: absolute;
        right: 0px;
        height: MpxTorem(90px);
        line-height: MpxTorem(90px);
        box-sizing: border-box;
        text-align: center;
        cursor: pointer;
        font-size: MpxTorem(36px);
      }

      .button-submit {
        border: 1px solid #000;
        background: #00b2ff;
        margin-right: MpxTorem(0px);
        margin-bottom: MpxTorem(20px);
        top: MpxTorem(110px);
        .button-a {
          color: #000;
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .button-login {
        top: MpxTorem(0px);
        padding: 0 MpxTorem(15px);
        background: #000;
        border: 1px solid #00b2ff;
        color: #00b2ff;
      }
    }

    .button-back {
      display: none;
    }
    .button-back--title {
      position: absolute;
      width: MpxTorem(800px);
      height: MpxTorem(100px);
      cursor: pointer;
      top: MpxTorem(100px);
      left: MpxTorem(98px);
    }
  }
}
</style>
